import { render } from "./AdmissionProcedures.vue?vue&type=template&id=3b429c8a&ts=true"
import script from "./AdmissionProcedures.vue?vue&type=script&lang=ts"
export * from "./AdmissionProcedures.vue?vue&type=script&lang=ts"

import "./AdmissionProcedures.vue?vue&type=style&index=0&id=3b429c8a&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__